import { defineComponent as _defineComponent } from 'vue'
import { SortMenuItem } from '@/types';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AgentExtensionReportSort',
  props: {
    modelValue: {
        type: Array<SortMenuItem>,
    },
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { t } = useI18n();

const sortMenuItems = ref([
    {
        label: t('report.realtimeAgentExtension.sortMenu.items.name'),
        key: 'name',
    },
    {
        label: t('report.realtimeAgentExtension.sortMenu.items.extension'),
        key: 'extension',
    },
] as SortMenuItem[]);

const props = __props;

const emit = __emit;

const updateValue = (value: SortMenuItem[]) => {
    emit('update:modelValue', value.slice(-1));
};

const __returned__ = { t, sortMenuItems, props, emit, updateValue }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})